<template>
  <div>
    <div
      class="tkTooltips_tool"
      @click="trigger === 'click' && (visible = true)"
      @mouseenter="trigger === 'hover' && showTips()"
      @mouseleave="trigger === 'hover' && scheduleToHide()"
    >
      <slot name="tool"></slot>
    </div>
    <div
      v-if="visible"
      class="tkTooltips_tipsWrapper -animated"
      :style="{ 'z-index': zIndex }"
      @mouseenter="trigger === 'hover' && cancelScheduleToHide()"
      @mouseleave="trigger === 'hover' && scheduleToHide()"
    >
      <div
        class="tkTooltips_tips"
        :style="{
          '--top': `${arrow ? offsetY + 15 : offsetY}px`,
          '--left': `${offsetX}px`,
        }"
      >
        <slot name="tips"></slot>
      </div>
      <div
        class="tkTooltips_arrow"
        :style="{
          '--top': `${-2.5 * arrowSize + offsetY + 15}px`,
          '--left': `${offsetX + arrowLeftPosition}px`,
          '--arrow-size': `${arrowSize}px`,
          '--arrow-color': arrowColor,
        }"
      />
    </div>
    <div
      v-if="trigger === 'click' && visible"
      class="tkTooltips_outside"
      :style="{ 'z-index': zIndex - 1 }"
      @click="visible = false"
    />
  </div>
</template>

<script>
export default {
  props: {
    // ツールチップが表示される操作
    // hover: マウスホバー, click: tool slot 内の要素対象のクリック
    trigger: {
      type: String,
      default: 'hover',  // 'hover', 'click'
    },
    // 吹き出しを表示するかどうか
    arrow: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true,
    },
    arrowSize: {
      type: Number,
      default: 10,
    },
    arrowLeftPosition: {
      type: Number,
      default: 30,
    },
    arrowColor: {
      type: String,
      default: '#dedfdf',  // サイトで使うカラーコードを一元管理したいところ
    },
    offsetX: {
      type: Number,
      default: 0,
    },
    offsetY: {
      type: Number,
      default: 0,
    },
    // ツールチップの z-index
    // trigger = click の場合の外側領域の z-index は -1 されたものになる
    zIndex: {
      type: Number,
      default: 10,
    },
    // PC画面でカーソルを外した後、ツールチップが非表示になるまでの時間(単位はms)
    delay: {
      type: Number,
      default: 300,
    }
  },

  data: () => ({
    visible: false,
    closeTimerId: undefined,
  }),

  methods: {
    showTips() {
      this.visible = true
      this.cancelScheduleToHide()
    },
    scheduleToHide() {
      this.cancelScheduleToHide()
      this.closeTimerId = setTimeout(() => {
        this.visible = false
      }, this.delay)
    },
    cancelScheduleToHide() {
      if (this.closeTimerId) {
        clearTimeout(this.closeTimerId)
        this.closeTimerId = undefined
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.tkTooltips_tool {
  display: inline-block;
  width: 100%;
}
.tkTooltips_tipsWrapper {
  position: relative;
  border-radius: 6px;

  &.-animated {
    animation: fadeIn 0.2s linear 1 forwards;
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}
.tkTooltips_tips {
  position: absolute;
  top: var(--top);
  left: var(--left);
  box-shadow: 0px 0px 4px #000000A1;
  border-radius: 6px;
  overflow: hidden;
}
.tkTooltips_arrow::after {
  position: absolute;
  top: var(--top);
  left: var(--left);
  -webkit-transform: scaleY(1.5);
  -ms-transform: scaleY(1.5);
  transform: scaleY(1.5);
  border: var(--arrow-size) solid transparent;
  border-bottom-color: var(--arrow-color);
  content: "";
}
.tkTooltips_outside {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
}
</style>
